module.exports = __webpack_public_path__ + "img/frown.7ab58022.svg";